import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgFilter = ({ size = 24, color = '$contentPrimary', ...inProps }: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <Path
        fill="currentColor"
        d="M17.75 20.25q-1.575 0-2.662-1.087Q14 18.075 14 16.5t1.088-2.662 2.662-1.088 2.663 1.088T21.5 16.5t-1.087 2.663-2.663 1.087m0-2q.725 0 1.238-.512.512-.513.512-1.238t-.512-1.238a1.69 1.69 0 0 0-1.238-.512q-.725 0-1.238.512A1.69 1.69 0 0 0 16 16.5q0 .725.512 1.238.513.512 1.238.512M11 17.5H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 16.5q0-.424.287-.713A.97.97 0 0 1 5 15.5h6q.424 0 .713.287.287.288.287.713 0 .424-.287.712A.97.97 0 0 1 11 17.5m-4.75-6.25q-1.575 0-2.662-1.088Q2.5 9.076 2.5 7.5t1.088-2.662Q4.675 3.75 6.25 3.75q1.576 0 2.662 1.088Q10 5.924 10 7.5t-1.088 2.662Q7.826 11.25 6.25 11.25m0-2q.725 0 1.237-.512Q8 8.225 8 7.5t-.513-1.237A1.69 1.69 0 0 0 6.25 5.75q-.725 0-1.237.513A1.69 1.69 0 0 0 4.5 7.5q0 .725.513 1.238.512.512 1.237.512M19 8.5h-6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 7.5q0-.424.287-.713A.97.97 0 0 1 13 6.5h6q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 19 8.5"
      />
    </Svg>
  );
};
export default SvgFilter;
